import { render } from "./DownloadConfirmModal.vue?vue&type=template&id=5c097408&scoped=true"
import script from "./DownloadConfirmModal.vue?vue&type=script&lang=js"
export * from "./DownloadConfirmModal.vue?vue&type=script&lang=js"

import "./DownloadConfirmModal.vue?vue&type=style&index=0&id=5c097408&scoped=true&lang=css"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c097408"]])

export default __exports__